// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application";

import PriceChartController from "./price_chart_controller";
import ModalController from "./modal_controller";

application.register("price-chart", PriceChartController);
application.register("modal", ModalController);
